export const roundWithDecimals = (
	value: number,
	decimals = 1
) => Math.round(value * 10 ** decimals) / 10 ** decimals;
